import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
export default {
  name: 'SearchableSelect',
  inheritAttrs: false,
  emits: ['update:modelValue', 'select', 'search'],
  props: {
    modelValue: {},
    options: {
      type: Array,
      default: function () {
        return [];
      }
    },
    valueField: {
      type: String,
      default: 'id'
    },
    labelField: {
      type: String,
      default: 'name'
    },
    translationField: {
      type: String,
      default: 'translation_key'
    },
    // Ha meg van adva: a legördülő az opciókat e mező szerint CSOPORTOSÍTVA jeleníti meg
    // (nem-választható fejléc + alatta az elemek). Üresen a régi, lapos lista.
    groupField: {
      type: String,
      default: ''
    },
    // Ha meg van adva: az opció e mezőjének értéke szerint BEHÚZVA áll (0 = nincs, 1 = egy szint), pl. egy
    // kérdés válaszai a kérdés alatt; ÉS a `searchField` szövegére is talál a kereső (pl. a válasznál a kérdésre).
    levelField: {
      type: String,
      default: ''
    },
    searchField: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    emptyValue: {
      default: null
    },
    // Ennyi elem FÖLÖTT vált a mező keresőre; alatta natív legördülőt ad.
    // 0 (az alapérték) = mindig kereső, ez a mező eredeti viselkedése.
    // A közös küszöb: utils/lookup-options.js SEARCHABLE_OPTION_THRESHOLD.
    threshold: {
      type: Number,
      default: 0
    },
    // Bootstrap méret ('sm' | 'lg'). Külön prop, mert ugyanahhoz a mérethez a
    // natív legördülő és a kereső MÁS osztálynevet kér (form-select-sm vs
    // form-control-sm), a hívó pedig nem tudja, melyik alakot kapja.
    size: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      focused: false,
      search: '',
      highlighted: -1,
      listStyle: {},
      listening: false
    };
  },
  computed: {
    // A szabály: ésszerű elemszám fölött kereső, alatta natív legördülő.
    searchable: function () {
      return this.threshold <= 0 || (this.options || []).length > this.threshold;
    },
    controlClass: function () {
      // A kereshető és a natív változat is selectként nézzen ki. Így hosszú
      // listánál sem vált át a vezérlő eltérő, sima input megjelenésre.
      const base = 'form-select';
      return [base, this.size ? base + '-' + this.size : '', this.invalid ? 'border-danger' : ''];
    },
    selectedOption: function () {
      return (this.options || []).find(option => String(option?.[this.valueField]) === String(this.modelValue));
    },
    // A natív legördülő értéke mindig szöveg; a modell viszont szám is lehet,
    // ezért a kiválasztott sort kódra keressük vissza, nem típusra hagyatkozunk.
    nativeValue: {
      get: function () {
        return this.modelValue === null || this.modelValue === undefined ? '' : String(this.modelValue);
      },
      set: function (raw) {
        const option = (this.options || []).find(item => String(item?.[this.valueField]) === String(raw));
        this.$emit('update:modelValue', option ? option[this.valueField] : this.emptyValue);
        this.$emit('select', option || null);
      }
    },
    filteredOptions: function () {
      const search = (this.search || '').toLowerCase();
      if (!search) {
        return this.options || [];
      }

      // csoportos listánál a csoport nevére, és a `searchField` szövegére keresve is megmarad az elem
      return (this.options || []).filter(option => {
        return this.getOptionLabel(option).toLowerCase().includes(search) || !!this.groupField && String(option?.[this.groupField] || '').toLowerCase().includes(search) || !!this.searchField && String(option?.[this.searchField] || '').toLowerCase().includes(search);
      });
    },
    // A szűrt opciók kategória szerint csoportosítva (csak ha groupField be van állítva).
    groupedOptions: function () {
      if (!this.groupField) {
        return [];
      }
      const groups = [];
      const index = new Map();
      this.filteredOptions.forEach(option => {
        const key = option?.[this.groupField] || '';
        if (!index.has(key)) {
          index.set(key, {
            group: key,
            items: []
          });
          groups.push(index.get(key));
        }
        index.get(key).items.push(option);
      });
      return groups;
    },
    // A megjelenő sorok EGY listában, csoport-fejlécekkel együtt: a billentyűs
    // léptetés így ugyanazt a sorrendet járja be, amit a szem lát.
    listRows: function () {
      const rows = [];
      let index = 0;
      if (!this.groupField) {
        this.filteredOptions.forEach(option => {
          rows.push({
            type: 'option',
            option: option,
            index: index++
          });
        });
        return rows;
      }
      this.groupedOptions.forEach(grp => {
        rows.push({
          type: 'group',
          group: grp.group
        });
        grp.items.forEach(option => {
          rows.push({
            type: 'option',
            option: option,
            index: index++
          });
        });
      });
      return rows;
    },
    hasValue: function () {
      return this.modelValue !== null && this.modelValue !== undefined && this.modelValue !== '';
    },
    navigableOptions: function () {
      return this.listRows.filter(row => row.type === 'option').map(row => row.option);
    },
    // A hívó által adott class/style a TELJES vezérlő méretét írja le (pl. egy
    // grid cella szélességét), nem csupán a belső inputét. Ez tartja együtt a
    // beviteli mezőt és a jobb oldali nyilat is.
    controlAttrs: function () {
      const attrs = {
        ...this.$attrs
      };
      delete attrs.class;
      delete attrs.style;
      return attrs;
    }
  },
  methods: {
    getOptionLabel: function (option = {}) {
      const translationKey = option?.[this.translationField];
      const label = translationKey ? this.$t(translationKey) : option?.[this.labelField];
      return typeof label === 'string' ? label.ucFirst() : String(label || '');
    },
    syncSearch: function () {
      this.search = this.selectedOption ? this.getOptionLabel(this.selectedOption) : '';
    },
    openList: function () {
      if (this.disabled) {
        return;
      }
      this.focused = true;

      // A friss nyitáskor a keresőt eddig a JELENLEGI érték szövege töltötte elő —
      // az a szöveg viszont a filteredOptions szűrőjeként is szolgál, tehát a lista
      // az esetek nagy részében EGYETLEN (az épp kiválasztott) sorra szűkült, mintha
      // más nem is volna választható. Nyitáskor ezért üres a kereső — a teljes lista
      // látszik —, a jelenlegi választás pedig kiemelve/görgetve marad látható.
      this.search = '';
      this.highlighted = this.selectedOption ? this.navigableOptions.findIndex(option => option === this.selectedOption) : -1;
      this.attachViewportListeners();
      this.$nextTick(() => {
        this.updatePosition();
        this.scrollHighlightedIntoView();
      });
    },
    handleSearch: function () {
      this.focused = true;
      this.highlighted = -1;
      const selectedLabel = this.selectedOption ? this.getOptionLabel(this.selectedOption) : '';
      if (!this.search || selectedLabel && this.search !== selectedLabel) {
        this.$emit('update:modelValue', this.emptyValue);
      }
      this.$emit('search', this.search);
      this.$nextTick(this.updatePosition);
    },
    selectOption: function (option = {}) {
      this.focused = false;
      this.highlighted = -1;
      this.detachViewportListeners();
      this.search = this.getOptionLabel(option);
      this.$emit('update:modelValue', option?.[this.valueField]);
      this.$emit('select', option);
    },
    clear: function (event) {
      event?.preventDefault();
      event?.stopPropagation();
      this.search = '';
      this.$emit('update:modelValue', this.emptyValue);
      this.$emit('select', null);
    },
    // választás után a mező fókuszban marad: a kattintás ilyenkor nem ad focus eseményt
    reopenList: function () {
      if (!this.focused) {
        this.openList();
      }
    },
    toggleList: function () {
      if (this.disabled) {
        return;
      }
      if (this.focused) {
        this.escapeList();
        this.$refs.control?.blur();
        return;
      }
      this.$refs.control?.focus();
      this.openList();
    },
    clearAndClose: function () {
      this.clear();
      this.escapeList();
    },
    closeList: function () {
      window.setTimeout(() => {
        this.focused = false;
        this.highlighted = -1;
        this.detachViewportListeners();
        this.syncSearch();
      }, 150);
    },
    // A natív legördülő billentyűzettel bejárható; a kereső csak akkor az, ha
    // a nyilak és az Enter is működnek rajta.
    moveHighlight: function (step) {
      if (!this.focused) {
        this.openList();
        return;
      }
      const count = this.navigableOptions.length;
      if (!count) {
        return;
      }
      this.highlighted = (this.highlighted + step + count) % count;
      this.$nextTick(this.scrollHighlightedIntoView);
    },
    chooseHighlighted: function () {
      const options = this.navigableOptions;
      // Nyíl nélkül is választható: ha a beírt szöveg egyetlen sorra szűkít,
      // az Enter azt veszi — ez a leggyakoribb gépelős eset.
      // A szerverről szűkülő listánál gépelés után még a régi lista áll: csak a beírt szövegre illő
      // egyetlen sort vesszük, különben egy korábbi találat kerülne be.
      const search = (this.search || '').toLowerCase();
      const single = options.length === 1 && (!search || this.getOptionLabel(options[0]).toLowerCase().includes(search)) ? options[0] : null;
      const option = options[this.highlighted] || single;
      if (option) {
        this.selectOption(option);
      }
    },
    // Az Esc a legbelső nyitott dolgot zárja: ha a lista áll nyitva, azt — és NEM
    // engedjük tovább, hogy a körülvevő modal is bezáruljon. Zárt listánál viszont
    // az Esc a modalé marad.
    escapeList: function (event) {
      if (!this.focused) {
        return;
      }
      event?.preventDefault();
      event?.stopPropagation();
      this.focused = false;
      this.highlighted = -1;
      this.detachViewportListeners();
      this.syncSearch();
    },
    scrollHighlightedIntoView: function () {
      const list = this.$refs.list;
      const item = list?.querySelector('.searchable-select-item.is-highlighted');
      if (item) {
        item.scrollIntoView({
          block: 'nearest'
        });
      }
    },
    // A lista a body-ba kerül és fix pozíciót kap, mert a mező gyakran görgethető
    // dobozban (foglalás-modal, kártya) ül, ami a saját határánál levágná. Cserébe
    // a helyét görgetés/átméretezés után újra kell számolni.
    updatePosition: function () {
      const control = this.$refs.control;
      if (!control) {
        return;
      }
      const rect = control.getBoundingClientRect();
      const margin = 8;
      const below = window.innerHeight - rect.bottom - margin;
      const above = rect.top - margin;
      // Ha alul nem fér el értelmes lista, fölfelé nyílik.
      const flip = below < 180 && above > below;
      const maxHeight = Math.max(120, Math.min(320, flip ? above : below));
      this.listStyle = Object.assign({
        position: 'fixed',
        left: rect.left + 'px',
        width: rect.width + 'px',
        maxHeight: maxHeight + 'px'
      }, flip ? {
        bottom: window.innerHeight - rect.top + 'px'
      } : {
        top: rect.bottom + 'px'
      });
    },
    attachViewportListeners: function () {
      if (this.listening) {
        return;
      }

      // capture: a görgetés bármelyik szülő dobozban történhet, nem csak az ablakon.
      window.addEventListener('scroll', this.updatePosition, true);
      window.addEventListener('resize', this.updatePosition);
      this.listening = true;
    },
    detachViewportListeners: function () {
      if (!this.listening) {
        return;
      }
      window.removeEventListener('scroll', this.updatePosition, true);
      window.removeEventListener('resize', this.updatePosition);
      this.listening = false;
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler: function () {
        if (!this.focused) {
          this.syncSearch();
        }
      }
    },
    options: {
      immediate: true,
      handler: function () {
        if (!this.focused) {
          this.syncSearch();
        }
      }
    }
  },
  beforeUnmount: function () {
    this.detachViewportListeners();
  }
};